import React from 'react';
import queryString from 'query-string';
import type ServicedeskQueuesConfigType from '@atlassian/jira-spa-apps-servicedesk-queues-config/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { type RouteContext, Redirect } from '@atlassian/react-resource-router';

/**
 * @deprecated remove when jsm_views_inside_queues_-_main_flag is cleaned up
 */
export const LazyServicedeskQueuesConfig = lazyForPaint<typeof ServicedeskQueuesConfigType>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-queues-config", jiraSpaEntry: "async-servicedesk-queues-config" */ '@atlassian/jira-spa-apps-servicedesk-queues-config/src/index.tsx'
		),
);

/**
 * @deprecated remove when jsm_views_inside_queues_-_main_flag is cleaned up
 */
export const ServicedeskQueuesConfig = (props: RouteContext): React.JSX.Element => {
	const { query } = props;

	// If URL is from edit queue, then redirect to the new URL with config query param
	if (!query.config) {
		const { config, ...restQuery } = query;
		return (
			<Redirect
				to={{
					pathname: `${props.location.pathname}`,
					hash: '',
					search: queryString.stringify({
						...restQuery,
						config: 'queueConfig',
					}),
				}}
			/>
		);
	}

	return (
		<LazyPage
			Page={LazyServicedeskQueuesConfig}
			pageId={`spa-apps/servicedesk/queues/config/${query.config}`}
			shouldShowSpinner
		/>
	);
};
